import { render, staticRenderFns } from "./file-carousel.vue?vue&type=template&id=ef50d1ec"
import script from "./file-carousel.vue?vue&type=script&lang=js"
export * from "./file-carousel.vue?vue&type=script&lang=js"
import style0 from "./file-carousel.vue?vue&type=style&index=0&id=ef50d1ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports